(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  if (event.defaultPrevented || event.button !== 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest(
    '.product-info__block-item[data-block-type="accordion"] a[href]'
  );
  if (!link) return;

  let url;
  try {
    url = new URL(link.href, window.location.href);
  } catch {
    return;
  }

  const allowedHosts = [
    window.location.hostname,
    'carlothelabel.com',
    'www.carlothelabel.com'
  ];

  if (!allowedHosts.includes(url.hostname)) return;

  const pathname = url.pathname.replace(/\/$/, '');
  let drawer = null;

  if (pathname === '/pages/size-guide') {
    const productInfo = link.closest('.product-info');
    const trigger = productInfo && productInfo.querySelector(
      'button[aria-controls^="size-chart-"]'
    );

    drawer = trigger && document.getElementById(
      trigger.getAttribute('aria-controls')
    );
  } else if (pathname === '/policies/shipping-policy') {
    drawer = document.getElementById('carlo-shipping-policy-drawer');
  } else if (pathname === '/policies/refund-policy') {
    drawer = document.getElementById('carlo-returns-policy-drawer');
  } else {
    return;
  }

  if (!drawer || drawer.tagName !== 'X-DRAWER' ||
      typeof drawer.show !== 'function') return;

  event.preventDefault();
  link.focus({ preventScroll: true });

  drawer.addEventListener('dialog:after-hide', function () {
    if (link.isConnected) link.focus({ preventScroll: true });
  }, { once: true });

  drawer.show();
});
  } catch(e) { console.error(e); }
})();

})();
